module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Wahlen-673cde19599be039d51966f8ab183d96.png";